import type { DatasetResource } from "@prequel/import-react";
import { useListDatasets } from "@prequel/import-react";
import type { TableRow } from "@prequel/shared-components";

import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";

const COLUMNS = ["Name", "Source", "Type", "Enabled", "Created"];

const mapDatasetToRow = (dataset: DatasetResource): TableRow => ({
  id: dataset.id,
  to: `/import/datasets/${dataset.id}`,
  cells: [
    { value: dataset.method === "table" ? dataset.table.source_table_name : dataset.id },
    { value: dataset.source_id },
    { value: dataset.type },
    { value: dataset.is_enabled ? "Yes" : "No" },
    { value: <Timestamp timestamp={dataset.created_at} /> },
  ],
});

const DatasetsTable = () => {
  return (
    <ResourceTable<DatasetResource>
      columns={COLUMNS}
      useQuery={useListDatasets}
      rowMapper={mapDatasetToRow}
      emptyMessage="No datasets configured."
    />
  );
};

export default DatasetsTable;
